import React from "react"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"
import CardAdditionalWork from "./CardAdditionalWork"
import { useSelector } from "react-redux"

const RightCard = ({ validation }) => {
  const store = useSelector(state => state)
  console.log("validation.values.assignments")
  console.log(validation.values.assignments)

  return (
    <Col sm="6">
      <h4 className="text-dark">作業時間を入力してください.</h4>
      {store.attendance.assignmentList.loading ? (
        <p>Loading...</p>
      ) : (
        validation.values.assignments
          .filter(j => j.checked)
          .map((i, k) => {
            const index = validation.values.assignments.findIndex(
              assign => assign.id == i.id
            )
            return (
              <Card className="p-1" key={k}>
                <CardHeader className="bg-white pb-0">
                  {i.orderNumber}/{i.customerName}/{i.productName}{" "}
                  {i.basting ? "(仮縫い)" : ""}
                </CardHeader>
                <CardBody className="pt-3 pb-1">
                  <Row>
                    <Col sm="12">
                      <h6>本日の作業時間</h6>
                    </Col>
                    <Col sm="6">
                      <FormGroup row>
                        <InputGroup>
                          <Input
                            name={`assignments[${index}].hour`}
                            className="form-control"
                            value={
                              validation.values.assignments[index]?.hour || ""
                            }
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched?.assignments &&
                              validation.errors?.assignments
                                ? validation.touched?.assignments[index]
                                    ?.hour &&
                                  validation.errors?.assignments[index]?.hour
                                  ? true
                                  : false
                                : false
                            }
                          />
                          <InputGroupText>時間</InputGroupText>
                          {validation.touched?.assignments &&
                          validation.errors?.assignments ? (
                            <FormFeedback type="invalid">
                              {validation.errors?.assignments[index]?.hour}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </FormGroup>
                    </Col>
                    <Col sm="6">
                      <FormGroup row>
                        <InputGroup>
                          <Input
                            name={`assignments[${index}].minute`}
                            className="form-control"
                            value={
                              validation.values.assignments[index]?.minute || ""
                            }
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.assignments &&
                              validation.errors.assignments
                                ? true
                                : false
                            }
                          />
                          <InputGroupText>分</InputGroupText>
                          {validation.touched?.assignments &&
                          validation.errors?.assignments ? (
                            <FormFeedback type="invalid">
                              {validation.errors?.assignments[index]?.minute}
                            </FormFeedback>
                          ) : null}
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )
          })
      )}
      <CardAdditionalWork validation={validation} />
    </Col>
  )
}

export default RightCard
